export default __webpack_public_path__ + "static/media/emergency-warning.b90c3e5d.png";